
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  AddCountryManagerRequest,
  AllManagerResponse,
  RemoveCountryManagerRequest,
  SupportedCountryWithManagers,
  UpdateReferralManagerRequest,
} from '../models';
import {
    AddCountryManagerRequestFromJSON,
    AddCountryManagerRequestToJSON,
    AllManagerResponseFromJSON,
    AllManagerResponseToJSON,
    RemoveCountryManagerRequestFromJSON,
    RemoveCountryManagerRequestToJSON,
    SupportedCountryWithManagersFromJSON,
    SupportedCountryWithManagersToJSON,
    UpdateReferralManagerRequestFromJSON,
    UpdateReferralManagerRequestToJSON,
} from '../models';

export interface AddCountryManagerOperationRequest {
    addCountryManagerRequest: AddCountryManagerRequest;
}

export interface RemoveCountryManagerOperationRequest {
    removeCountryManagerRequest: RemoveCountryManagerRequest;
}

export interface UpdateManagerRequest {
    submissionId: string;
    updateReferralManagerRequest: UpdateReferralManagerRequest;
}

/**
 * 
 */
export class EligibilityManagersApi extends runtime.BaseAPI {

    /**
     * Add a country manager for a given country
          */
    async addCountryManagerRaw(requestParameters: AddCountryManagerOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['addCountryManagerRequest'] == null) {
            throw new runtime.RequiredError(
                'addCountryManagerRequest',
                'Required parameter "addCountryManagerRequest" was null or undefined when calling addCountryManager().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/business-referral/api/eligibility/managers/country-managers-per-country`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AddCountryManagerRequestToJSON(requestParameters['addCountryManagerRequest']),
        }, initOverrides);

        return response;
    }

    /**
     * Add a country manager for a given country
          */
    async addCountryManager(requestParameters: AddCountryManagerOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.addCountryManagerRaw(requestParameters, initOverrides);
    }

    /**
     * Retrieve all sales, country and community managers
          */
    async getAllManagersRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<AllManagerResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<AllManagerResponse>({
            path: `/business-referral/api/eligibility/managers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=AllManagerResponseFromJSON(response._data); }
        return response;
    }

    /**
     * Retrieve all sales, country and community managers
          */
    async getAllManagers(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<AllManagerResponse> {
        const response = await this.getAllManagersRaw(initOverrides);
        return response._data;
    }

    /**
     * Retrieve all platform supported countries and its associated managers
          */
    async getAllSupportedCountriesWithManagersRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<Array<SupportedCountryWithManagers>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<Array<SupportedCountryWithManagers>>({
            path: `/business-referral/api/eligibility/managers/country-managers-per-country`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        response._data=response._data?.map(SupportedCountryWithManagersFromJSON);
        return response;
    }

    /**
     * Retrieve all platform supported countries and its associated managers
          */
    async getAllSupportedCountriesWithManagers(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<Array<SupportedCountryWithManagers>> {
        const response = await this.getAllSupportedCountriesWithManagersRaw(initOverrides);
        return response._data;
    }

    /**
     * Remove a country manager for a given country
          */
    async removeCountryManagerRaw(requestParameters: RemoveCountryManagerOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['removeCountryManagerRequest'] == null) {
            throw new runtime.RequiredError(
                'removeCountryManagerRequest',
                'Required parameter "removeCountryManagerRequest" was null or undefined when calling removeCountryManager().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/business-referral/api/eligibility/managers/country-managers-per-country`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: RemoveCountryManagerRequestToJSON(requestParameters['removeCountryManagerRequest']),
        }, initOverrides);

        return response;
    }

    /**
     * Remove a country manager for a given country
          */
    async removeCountryManager(requestParameters: RemoveCountryManagerOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.removeCountryManagerRaw(requestParameters, initOverrides);
    }

    /**
     * Update manager for a given category related to the referral submission
          */
    async updateManagerRaw(requestParameters: UpdateManagerRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['submissionId'] == null) {
            throw new runtime.RequiredError(
                'submissionId',
                'Required parameter "submissionId" was null or undefined when calling updateManager().'
            );
        }

        if (requestParameters['updateReferralManagerRequest'] == null) {
            throw new runtime.RequiredError(
                'updateReferralManagerRequest',
                'Required parameter "updateReferralManagerRequest" was null or undefined when calling updateManager().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/business-referral/api/eligibility/{submissionId}/managers`.replace(`{${"submissionId"}}`, encodeURIComponent(String(requestParameters['submissionId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateReferralManagerRequestToJSON(requestParameters['updateReferralManagerRequest']),
        }, initOverrides);

        return response;
    }

    /**
     * Update manager for a given category related to the referral submission
          */
    async updateManager(requestParameters: UpdateManagerRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.updateManagerRaw(requestParameters, initOverrides);
    }

}
